import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../config/api';

function Pricing() {
  const [pricings, setPricings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPricings = async () => {
      try {
        const response = await api.get('/pricing');
        const data = response.data;

        if (data.success && Array.isArray(data.data)) {
          setPricings(data.data);
        } else {
          setPricings([]);
        }
      } catch (error) {
        console.error('Error fetching pricing plans:', error);
        setPricings([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPricings();
  }, []);

  // Animation delay classes for staggered effect
  const getDelayClass = (index) => {
    const delays = ['delay-0-2s', 'delay-0-4s', 'delay-0-6s'];
    return delays[index % delays.length];
  };

  return (
    <>
      <section className="page-banner bg-blue rel z-1" style={{backgroundImage: 'url(/assets/images/background/banner-bg.png)'}}>
        <div className="container">
          <div className="banner-inner">
            <h1 className="page-title wow fadeInUp delay-0-2s">Plans and Pricing</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">Plans and Pricing</li>
              </ol>
            </nav>
          </div>
        </div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots-two.png" alt="Shape" />
        <img className="tringle-shape slideLeftRight" src="/assets/images/shapes/white-tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/white-close.png" alt="Shape" />
        <img src="/assets/images/newsletter/circle.png" alt="shape" className="banner-circle slideUpRight" />
        <img className="dots-shape-three slideUpDown delay-1-5s" src="/assets/images/shapes/white-dots-three.png" alt="Shape" />
      </section>

      <section className="pricing-section rel z-1 bg-gray pt-130 rpt-100 pb-100 rpb-70">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7 col-lg-8 col-md-10">
              <div className="section-title text-center text-white mb-45">
                <span className="sub-title">Pricing Package</span>
                <h2>Make The Wise Decision For Software Solutions</h2>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="row justify-content-center">
              <div className="col-12 text-center text-white">
                <p>Loading pricing plans...</p>
              </div>
            </div>
          ) : pricings.length === 0 ? (
            <div className="row justify-content-center">
              <div className="col-12 text-center text-white">
                <p>No pricing plans available at the moment.</p>
              </div>
            </div>
          ) : (
            <div className="row justify-content-center align-items-stretch">
              {pricings.map((pricing, index) => (
                <div key={pricing.id} className="col-lg-4 col-md-6 mb-4 d-flex">
                  <div className={`pricing-item wow fadeInUp ${getDelayClass(index)} w-100`} style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <h5 className="price-title mb-4" style={{
                      fontSize: '26px',
                      fontWeight: 'bold',
                      marginTop: '10px',
                      marginBottom: '20px'
                    }}>
                      {pricing.title}
                    </h5>
                    <div className="mb-3" style={{minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <span style={{
                        fontSize: 'clamp(32px, 4vw, 42px)',
                        fontWeight: 'bold',
                        color: '#4A90E2',
                        lineHeight: '1.2',
                        wordBreak: 'break-word'
                      }}>
                        {pricing.price}
                      </span>
                    </div>
                    {pricing.user_range && (
                      <p className="mb-4" style={{
                        color: '#718096',
                        fontSize: '15px',
                        fontWeight: 500,
                        minHeight: '24px'
                      }}>
                        {pricing.user_range}
                      </p>
                    )}
                    <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                      <a href="/contact" className="theme-btn mb-4" style={{
                        display: 'inline-block',
                        padding: '14px 32px',
                        fontSize: '15px',
                        fontWeight: 600,
                        textDecoration: 'none',
                        borderRadius: '8px',
                        width: '100%',
                        textAlign: 'center',
                        marginBottom: '30px'
                      }}>
                        Choose Package <i className="fas fa-long-arrow-alt-right"></i>
                      </a>
                      <ul className="list-style-one" style={{
                        paddingLeft: '0',
                        listStyle: 'none',
                        margin: '0',
                        textAlign: 'left'
                      }}>
                        {pricing.features && pricing.features.length > 0 && 
                          pricing.features.map((feature, featureIndex) => (
                            <li key={featureIndex} style={{
                              marginBottom: '12px',
                              fontSize: '15px',
                              lineHeight: '1.6',
                              display: 'flex',
                              alignItems: 'flex-start',
                              paddingLeft: '24px',
                              position: 'relative'
                            }}>
                              <i className="fas fa-check-circle" style={{
                                position: 'absolute',
                                left: '0',
                                top: '4px',
                                color: '#4A90E2',
                                fontSize: '16px'
                              }}></i>
                              <span>{feature}</span>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="section-alpha-text">Our Pricing Plan</div>
        <img className="dots-shape" src="/assets/images/shapes/white-dots.png" alt="Shape" />
        <img className="tringle-shape" src="/assets/images/shapes/tringle.png" alt="Shape" />
        <img className="close-shape" src="/assets/images/shapes/yellow-close.png" alt="Shape" />
        <div className="left-circles"></div>
        <div className="right-circles"></div>
      </section>

      <div className="for-gap pb-160 rpb-100"></div>
    </>
  );
}

export default Pricing;

